/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AccessToken } from '../model';
// @ts-ignore
import { AccessTokenResponse } from '../model';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { PasswordObject } from '../model';
// @ts-ignore
import { PasswordRegisterRequest } from '../model';
// @ts-ignore
import { PasswordUpdateRequest } from '../model';
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This generates a new access token out of a provided API key with the same scopes. 
         * @summary Generates access token
         * @param {string} xAPIKEY 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateAccessToken: async (xAPIKEY: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAPIKEY' is not null or undefined
            assertParamExists('generateAccessToken', 'xAPIKEY', xAPIKEY)
            const localVarPath = `/v1/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (xAPIKEY !== undefined && xAPIKEY !== null) {
                localVarHeaderParameter['X-API-KEY'] = String(xAPIKEY);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This generates a new access token. This needs to use a hashed password.
         * @summary Login with password
         * @param {PasswordObject} passwordObject 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        loginWithPassword: async (passwordObject: PasswordObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordObject' is not null or undefined
            assertParamExists('loginWithPassword', 'passwordObject', passwordObject)
            const localVarPath = `/v1/entity/access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = passwordObject

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This generates a new access token. This request header requires `Signature` to check if the requester has a correct private key.
         * @summary Login with Signature
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        loginWithSignature: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/entity/access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication signature required
            await setApiKeyToObject(localVarHeaderParameter, "Signature", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This initiates sets up a new password. This needs raw identities and claim values. This validates the password on the backend, so this needs a raw password.
         * @summary Password registration
         * @param {PasswordRegisterRequest} passwordRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPassword: async (passwordRegisterRequest: PasswordRegisterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordRegisterRequest' is not null or undefined
            assertParamExists('registerPassword', 'passwordRegisterRequest', passwordRegisterRequest)
            const localVarPath = `/v1/entity/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = passwordRegisterRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This generates a new access token with an old access token.
         * @summary Renew access token
         * @param {AccessToken} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewAccessToken: async (accessToken: AccessToken, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('renewAccessToken', 'accessToken', accessToken)
            const localVarPath = `/v1/entity/access-token/renew`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = accessToken

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This updates a existing password. This validates the password on the backend, so this needs a raw password for `new_password`.
         * @summary Password update
         * @param {PasswordUpdateRequest} passwordUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (passwordUpdateRequest: PasswordUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordUpdateRequest' is not null or undefined
            assertParamExists('updatePassword', 'passwordUpdateRequest', passwordUpdateRequest)
            const localVarPath = `/v1/entity/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = passwordUpdateRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * This generates a new access token out of a provided API key with the same scopes. 
         * @summary Generates access token
         * @param {string} xAPIKEY 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async generateAccessToken(xAPIKEY: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAccessToken(xAPIKEY, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This generates a new access token. This needs to use a hashed password.
         * @summary Login with password
         * @param {PasswordObject} passwordObject 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async loginWithPassword(passwordObject: PasswordObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithPassword(passwordObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This generates a new access token. This request header requires `Signature` to check if the requester has a correct private key.
         * @summary Login with Signature
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async loginWithSignature(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithSignature(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This initiates sets up a new password. This needs raw identities and claim values. This validates the password on the backend, so this needs a raw password.
         * @summary Password registration
         * @param {PasswordRegisterRequest} passwordRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerPassword(passwordRegisterRequest: PasswordRegisterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerPassword(passwordRegisterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This generates a new access token with an old access token.
         * @summary Renew access token
         * @param {AccessToken} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renewAccessToken(accessToken: AccessToken, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renewAccessToken(accessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This updates a existing password. This validates the password on the backend, so this needs a raw password for `new_password`.
         * @summary Password update
         * @param {PasswordUpdateRequest} passwordUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(passwordUpdateRequest: PasswordUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(passwordUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * This generates a new access token out of a provided API key with the same scopes. 
         * @summary Generates access token
         * @param {string} xAPIKEY 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateAccessToken(xAPIKEY: string, options?: any): AxiosPromise<AccessTokenResponse> {
            return localVarFp.generateAccessToken(xAPIKEY, options).then((request) => request(axios, basePath));
        },
        /**
         * This generates a new access token. This needs to use a hashed password.
         * @summary Login with password
         * @param {PasswordObject} passwordObject 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        loginWithPassword(passwordObject: PasswordObject, options?: any): AxiosPromise<AccessTokenResponse> {
            return localVarFp.loginWithPassword(passwordObject, options).then((request) => request(axios, basePath));
        },
        /**
         * This generates a new access token. This request header requires `Signature` to check if the requester has a correct private key.
         * @summary Login with Signature
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        loginWithSignature(options?: any): AxiosPromise<AccessTokenResponse> {
            return localVarFp.loginWithSignature(options).then((request) => request(axios, basePath));
        },
        /**
         * This initiates sets up a new password. This needs raw identities and claim values. This validates the password on the backend, so this needs a raw password.
         * @summary Password registration
         * @param {PasswordRegisterRequest} passwordRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPassword(passwordRegisterRequest: PasswordRegisterRequest, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.registerPassword(passwordRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This generates a new access token with an old access token.
         * @summary Renew access token
         * @param {AccessToken} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewAccessToken(accessToken: AccessToken, options?: any): AxiosPromise<AccessTokenResponse> {
            return localVarFp.renewAccessToken(accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This updates a existing password. This validates the password on the backend, so this needs a raw password for `new_password`.
         * @summary Password update
         * @param {PasswordUpdateRequest} passwordUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(passwordUpdateRequest: PasswordUpdateRequest, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.updatePassword(passwordUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - interface
 * @export
 * @interface AuthApi
 */
export interface AuthApiInterface {
    /**
     * This generates a new access token out of a provided API key with the same scopes. 
     * @summary Generates access token
     * @param {string} xAPIKEY 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    generateAccessToken(xAPIKEY: string, options?: AxiosRequestConfig): AxiosPromise<AccessTokenResponse>;

    /**
     * This generates a new access token. This needs to use a hashed password.
     * @summary Login with password
     * @param {PasswordObject} passwordObject 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    loginWithPassword(passwordObject: PasswordObject, options?: AxiosRequestConfig): AxiosPromise<AccessTokenResponse>;

    /**
     * This generates a new access token. This request header requires `Signature` to check if the requester has a correct private key.
     * @summary Login with Signature
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    loginWithSignature(options?: AxiosRequestConfig): AxiosPromise<AccessTokenResponse>;

    /**
     * This initiates sets up a new password. This needs raw identities and claim values. This validates the password on the backend, so this needs a raw password.
     * @summary Password registration
     * @param {PasswordRegisterRequest} passwordRegisterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    registerPassword(passwordRegisterRequest: PasswordRegisterRequest, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This generates a new access token with an old access token.
     * @summary Renew access token
     * @param {AccessToken} accessToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    renewAccessToken(accessToken: AccessToken, options?: AxiosRequestConfig): AxiosPromise<AccessTokenResponse>;

    /**
     * This updates a existing password. This validates the password on the backend, so this needs a raw password for `new_password`.
     * @summary Password update
     * @param {PasswordUpdateRequest} passwordUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    updatePassword(passwordUpdateRequest: PasswordUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * This generates a new access token out of a provided API key with the same scopes. 
     * @summary Generates access token
     * @param {string} xAPIKEY 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public generateAccessToken(xAPIKEY: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).generateAccessToken(xAPIKEY, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This generates a new access token. This needs to use a hashed password.
     * @summary Login with password
     * @param {PasswordObject} passwordObject 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginWithPassword(passwordObject: PasswordObject, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).loginWithPassword(passwordObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This generates a new access token. This request header requires `Signature` to check if the requester has a correct private key.
     * @summary Login with Signature
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginWithSignature(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).loginWithSignature(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This initiates sets up a new password. This needs raw identities and claim values. This validates the password on the backend, so this needs a raw password.
     * @summary Password registration
     * @param {PasswordRegisterRequest} passwordRegisterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public registerPassword(passwordRegisterRequest: PasswordRegisterRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).registerPassword(passwordRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This generates a new access token with an old access token.
     * @summary Renew access token
     * @param {AccessToken} accessToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public renewAccessToken(accessToken: AccessToken, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).renewAccessToken(accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This updates a existing password. This validates the password on the backend, so this needs a raw password for `new_password`.
     * @summary Password update
     * @param {PasswordUpdateRequest} passwordUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public updatePassword(passwordUpdateRequest: PasswordUpdateRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).updatePassword(passwordUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
